import { Link, useLocation } from 'react-router-dom';
import { Calendar, Dumbbell, Home, BarChart3, Timer } from 'lucide-react';
import { getAppText, useLanguageStore } from '../../stores/languageStore';
import { triggerCrazyMenuBurst } from '../../utils/crazyBurst';

const tabs = [
  { href: '/', labelKey: 'start', icon: Home },
  { href: '/activities', labelKey: 'activities', icon: Dumbbell },
  { href: '/calendar', labelKey: 'calendar', icon: Calendar },
  { href: '/training', labelKey: 'training', icon: Timer },
  { href: '/stats', labelKey: 'stats', icon: BarChart3 },
];

const isTabActive = (pathname, href) => {
  if (href === '/activities') {
    return ['/activities', '/exercises', '/workouts'].includes(pathname);
  }

  if (href === '/training') {
    return ['/training', '/timer'].includes(pathname);
  }

  return pathname === href;
};

export const MobileTabBar = () => {
  const location = useLocation();
  const { appLanguage } = useLanguageStore();
  const t = getAppText(appLanguage);

  const handleTabClick = (event) => {
    triggerCrazyMenuBurst(event.currentTarget);
  };

  return (
    <nav className="mobile-tabbar md:hidden" aria-label={t.mobileNavAria}>
      <div className="mobile-tabbar-inner">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = isTabActive(location.pathname, tab.href);

          return (
            <Link
              key={tab.href}
              to={tab.href}
              onClick={handleTabClick}
              className={`mobile-tab-item ${active ? 'mobile-tab-item-active' : ''}`}
            >
              <span className={`mobile-tab-icon-wrap ${active ? 'mobile-tab-icon-wrap-active' : ''}`}>
                <Icon className="h-5 w-5" aria-hidden="true" />
              </span>
              <span>{t[tab.labelKey]}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
